export default __webpack_public_path__ + "static/media/Smart_Timelapse_trimmed.efc5ae3e.mp4";